import { TypedHandler } from './../../../types/handlers';
import { Project } from './../../../model/project';
import { ProjectConfig } from './../../../types/project-config';

import { EventEmitter, Injectable } from '@angular/core';
import { SimpleHandler } from 'app/types/handlers';
import { PrjSaveMessage } from '../project-save-dialog/project-save-entry.component';

export type PrjCfgShowParams = {
  projectId?: number;
  updateHandler?: TypedHandler<PrjSaveMessage>;
}
@Injectable({
  providedIn: 'root'
})
export class ProjectConfigDialogService {
  public requests = new EventEmitter<PrjCfgShowParams>();
  constructor() { }
  Show(projectId?: any | string, updateHandler?: TypedHandler<PrjSaveMessage>): void {
    this.requests.emit({ projectId: (!!projectId ? Number(projectId) : projectId), updateHandler: (updateHandler) });
  }

}
